import * as React from 'react';
import { cn } from '@/lib/utils';

export interface FieldsetGroupProps {
  legend: string;
  /** Keeps the grouping for assistive tech where the design shows no heading. */
  hideLegend?: boolean;
  children: React.ReactNode;
  className?: string;
}

/**
 * The UA gives <fieldset> `min-inline-size: min-content`, so without min-w-0 a
 * long option label refuses to shrink and pushes its flex/grid parent wide.
 */
const FieldsetGroup: React.FC<FieldsetGroupProps> = ({
  legend,
  hideLegend,
  children,
  className,
}) => (
  <fieldset className={cn('m-0 min-w-0 p-0', className)}>
    <legend
      className={cn(
        hideLegend ? 'sr-only' : 'revy-cjk mb-2 p-0 text-sm font-medium leading-[1.5]',
      )}
    >
      {legend}
    </legend>
    <div className="flex flex-col gap-2.5">{children}</div>
  </fieldset>
);

export { FieldsetGroup };
